import { useNativeState } from '@shared/core/native';
import { BoxProps } from '@withjoy/joykit';
import React from 'react';

import { StyledPage, styles } from './LayoutStructure.styles';

interface PageProps extends Readonly<BoxProps> {}

export const Page: React.FC<PageProps> = props => {
  const { isNative } = useNativeState();
  return <StyledPage __css={styles.page} paddingTop={isNative ? 8 : { _: 0, md: 7 }} {...props} />;
};
